import { AbstractViewProperties } from "../../view/properties/AbstractViewProperties";
import { ControlConstants } from "../constant/ControlConstants";
/**
 * TextFieldProperties.ts
 */
export class TextFieldProperties extends AbstractViewProperties {
    constructor(style, position = null, langKey = null, horizontalAlign, verticalAlign, size) {
        super(position);
        this.styleId = style;
        this.fontProperties = this.getFont(style);
        this.langKey = langKey;
        this.horizontalAlign = horizontalAlign || ControlConstants.CENTER;
        this.verticalAlign = verticalAlign || ControlConstants.CENTER;
        this.multiline = false;
        this.autoResize = true;
        this.rotation = 0;
        this.size = size;
        this._resizes = 0;
    }
    equals(other) {
        return (super.equals(other) &&
            this.styleId === other.styleId &&
            this.fontProperties.equals(other.fontProperties) &&
            this.langKey === other.langKey &&
            this.horizontalAlign === other.horizontalAlign &&
            this.verticalAlign === other.verticalAlign &&
            this.multiline === other.multiline &&
            this.autoResize === other.autoResize &&
            this.rotation === other.rotation &&
            this.backgroundProperties === other.backgroundProperties &&
            (this.size
                ? this.size.equals(other.size)
                : this.size === other.size));
    }
    setHorizontalAlign(value) {
        this.horizontalAlign = value;
        return this;
    }
    setVerticalAlign(value) {
        this.verticalAlign = value;
        return this;
    }
    setRotation(value) {
        this.rotation = value;
        return this;
    }
    setMultiline(value) {
        this.multiline = value;
        return this;
    }
    /**
     * Clone `this` but change the styleId
     * @param style - New style
     * @returns New copy
     */
    copyTo(style) {
        return new TextFieldProperties(style, this.position?.clone(), this.langKey, this.horizontalAlign, this.verticalAlign, this.size?.clone());
    }
}
//# sourceMappingURL=TextFieldProperties.js.map